import { message } from "antd";
import { ReactElement, useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { IDeleteDocumentHandlerProps } from "../../../../../interfaces/props/IDeleteDocumentHandlerProps";
import { IDownloadDocumentHandlerProps } from "../../../../../interfaces/props/IDownloadDocumentHandlerProps";
import { useDeleteAdditionalDocumentMutation } from "../../../../../store/api/applicationBankApi/documents.api";
import {
  AdditionalDocument,
  IApplicationDataToBank,
} from "../../../../../store/slice/applicationDataToBankSlice/applicationDataToBankSlice";
import { DocumentKkb } from "../../../../../store/slice/requestAppSlise/requestAppSlise";
import { ApplicationBankStatus } from "../../../../../utils/guards/ApplicationBankStatusGuard/types";
import { DownloadingFiles } from "../../../../../utils/utilities/Downloads";
import AdditionalDocCard from "../../../DocList/AdditionalDocCard/AdditionalDocCard";
import { TagSign } from "../TagSign/TagSign";

interface ApplicationDetailsDocSectionProps {
  documents: AdditionalDocument[];
  section: keyof IApplicationDataToBank["documents"];
  status: ApplicationBankStatus;
}

/**
 * Список карт дополнительных документов (карточки документов с возможностью скачивания)
 */
export function ApplicationDetailsAdditionalDocSection(
  props: ApplicationDetailsDocSectionProps,
): ReactElement {
  const { documents, section, status } = props;
  const { applicationBankId, applicationId } = useParams();

  const [errors] = useState<string[]>([]);
  const [deleteAdditionalDocument, { isLoading: isDeleting }] =
    useDeleteAdditionalDocumentMutation();

  const downloadDocumentCallback = useCallback(
    ({ name, document_id }: IDownloadDocumentHandlerProps) => {
      if (name && document_id && applicationBankId) {
        const urlFile = {
          url: `auth/applications/system-bank/create-data-to-bank/${applicationBankId}/file/${document_id}`,
          fileName: `${name}`,
        };
        DownloadingFiles(urlFile);
      }
    },
    [applicationBankId],
  );

  const deleteDocumentCallback = useCallback(
    ({ document_id }: IDeleteDocumentHandlerProps) => {
      if (applicationBankId && document_id) {
        deleteAdditionalDocument({
          applicationBankId: Number(applicationBankId),
          additionalDocumentId: document_id,
          applicationId: Number(applicationId),
        });
      } else {
        message.error("Что-то пошло не так");
      }
    },
    [],
  );

  return (
    <div style={{ paddingBottom: "24px", cursor: "pointer" }}>
      {section === "additionalDocument" &&
        documents[0].document?.map((doc: DocumentKkb, index: number) => {
          return (
            <AdditionalDocCard
              status={status}
              key={doc.id}
              item={{
                ...documents[0],
                document: doc ?? null,
              }}
              Tag={
                doc && (
                  <TagSign
                    tag={!!doc?.sign_file?.length ? "sign_true" : "sign_false"}
                  />
                )
              }
              loadingDocument={isDeleting}
              index={index}
              error={errors[index]}
              downloadDocumentCallback={downloadDocumentCallback}
              deleteDocumentCallback={deleteDocumentCallback}
            />
          );
        })}
    </div>
  );
}
